export default "__VITE_PUBLIC_ASSET__22f4c923__"